import { type InitOptions } from 'i18next';
import {
  AUTHORIZED_LANGUAGES,
  DEBUG_LANGUAGE,
  DEFAULT_LANGUAGE,
  IS_DEV,
  IS_STAGING,
  TRANSLATIONS_ENDPOINT_URI,
} from '@/constants';

export const i18nConfig: InitOptions = {
  load: 'languageOnly',
  preload: AUTHORIZED_LANGUAGES,
  fallbackLng: IS_DEV || IS_STAGING ? DEBUG_LANGUAGE : DEFAULT_LANGUAGE,
  returnEmptyString: false,
  defaultNS: 'messages',
  ns: 'messages',
  backend: {
    loadPath: `${TRANSLATIONS_ENDPOINT_URI}/{{ns}}.{{lng}}.json`,
    crossDomain: true,
  },
  react: {
    bindI18n: 'languageChanged',
    bindI18nStore: false,
    useSuspense: false,
  },
  detection: {
    order: ['querystring', 'localStorage'],
  },
};
